import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {isAgencyServerCMSArticle, isAgencyServerDevProjectArticle, isAgencyServerShopArticle, isConfigurableArticle} from "../../selectors/ArticleNumbers";

export const TermsText = (props) => {

    let termsText = <Fragment>
        Mit Klick auf „{props.label}“ erkläre ich,
        dass ich mit der Geltung der <a href="https://www.mittwald.de/agb" target="_blank">AGB</a> einverstanden bin.
        Die <a href="https://www.mittwald.de/datenschutz" target="_blank">Datenschutzhinweise</a> habe ich zur Kenntnis
        genommen.
    </Fragment>;

    if (props.article === '75000' || props.article === '75001' || props.article === '75002' || props.article === '75003') {
        termsText = <Fragment>
            Mit Klick auf „{props.label}“ erkläre ich, dass ich mit der Geltung der <a href="https://www.mittwald.de/agb" target="_blank">AGB</a> und den <a target="_blank" href="https://www.mittwald.de/lizenzbedingungen-typo3-elts">besonderen Geschäftsbedingungen für TYPO3 Extended Long Term Support
            (ELTS)</a> einverstanden bin.
            Die <a href="https://www.mittwald.de/datenschutz" target="_blank">Datenschutzhinweise</a> sowie die Regelungen zur <br/><a href="https://www.mittwald.de/services/php-extended-support" target="_blank">Verwendung von PHP-Versionen</a> habe ich zur Kenntnis genommen.
        </Fragment>
    } else if (props.article === '30000') {
        termsText = <Fragment>
            Mit Klick auf „{props.label}“ erkläre ich,
            dass ich mit der Geltung der <a href="https://www.mittwald.de/agb" target="_blank">AGB</a> und <a href="https://www.mittwald.de/partnerprogramm-agb" target="_blank">Partner-AGB</a> einverstanden bin.
            Die <a href="https://www.mittwald.de/datenschutz" target="_blank">Datenschutzhinweise</a> habe ich zur Kenntnis
            genommen.
        </Fragment>
    } else if (props.article === '191025' || props.article === '191026') {
        termsText = <Fragment>
            Mit Klick auf „{props.label}“ erkläre ich, dass ich mit der Geltung der <a href="https://www.mittwald.de/agb" target="_blank">AGB</a> und den <a target="_blank" href="https://www.mittwald.de/services/av-manager/lizenzbedingungen">besonderen Bedingungen für die Nutzung des
            AV-Managers</a> einverstanden bin. Die <a href="https://www.mittwald.de/datenschutz" target="_blank">Datenschutzhinweise</a> und den <a href="https://www.mittwald.de/services/av-manager/lizenzbedingungen#haftungshinweis" target="_blank">Haftungshinweis zum AV-Manager</a> habe ich zur
            Kenntnis genommen.
        </Fragment>
    } else if (
        props.article && (
            isAgencyServerCMSArticle(props.article) ||
            isAgencyServerShopArticle(props.article) ||
            isAgencyServerDevProjectArticle(props.article) ||
            isConfigurableArticle(props.article)
        )
    ) {
        termsText = <Fragment>
            Mit Klick auf „{props.label}“ erkläre ich,
            dass ich mit der Geltung der <a href="https://www.mittwald.de/agb" target="_blank">AGB</a> einverstanden bin.
            Die <a href="https://www.mittwald.de/datenschutz" target="_blank">Datenschutzhinweise</a> sowie die Regelungen zur <br/><a href="https://www.mittwald.de/services/php-extended-support" target="_blank">Verwendung von PHP-Versionen</a> habe ich zur Kenntnis
            genommen.
        </Fragment>;
    }

    return termsText;

};

TermsText.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/summary/TermsText.js
 **/